import React from 'react';
import { useContractState } from '../../context/ContractContext';
import { formatUSDT, toNumberSafe } from '../../utils/format';

export default function CeilingCard() {
  const { investments, ceilingTotal, earnedTotal } = useContractState();

  const earnedN = toNumberSafe(earnedTotal);
  const ceilN   = toNumberSafe(ceilingTotal);
  const pct     = ceilN > 0 ? Math.min(100, (earnedN / ceilN) * 100) : 0;

  // Ticks at 25/50/75%
  const ticks = [25, 50, 75];

  return (
    <div className="ceiling-card">
      <div className="head">
        <h3>Total Ceiling</h3>
        <div className="pct">{pct.toFixed(1)}%</div>
      </div>
      <div className="row1">
        <div className="earned">{formatUSDT(earnedTotal)}</div>
        <div className="cap">/ {formatUSDT(ceilingTotal)}</div>
      </div>

      <div className="gaming-bar">
        <div className="fill" style={{ width: `${pct}%` }} />
        {ticks.map(t => <span key={t} className="tick" style={{ left: `${t}%` }} />)}
      </div>

      <div className="pkg-grid">
        {(investments || []).map((inv, i) => {
          const e = toNumberSafe(inv.roiEarned) + toNumberSafe(inv.levelIncomeEarned);
          const c = toNumberSafe(inv.ceilingAmount);
          const p = c > 0 ? Math.min(100, (e / c) * 100) : 0;
          return (
            <div key={i} className={`pkg-tile ${!inv.active ? 'filled' : ''}`}>
              <div className="amt">{formatUSDT(inv.amount, { decimals: 0 })}</div>
              <div className="pct">{p.toFixed(0)}% filled</div>
              <div className="mini-bar"><div className="fill" style={{ width: `${p}%` }} /></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
